import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import contests from './contests';
import cheers from './cheers';
import currentUser from './currentUser';
import account from './account';
import admin from './admin';
import ideas from './ideas';
import posts from './posts';

const rootReducer = combineReducers({
    routing: routerReducer,
    initial: (state = {}) => ({ ...state }),
    account,
    admin,
    contests,
    cheers,
    currentUser,
    ideas,
    posts,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js